import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.View.extend({
  events: {
    'click #resend-block a': 'resend_verify',
  },

  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.form = options.form;
    this.form.on('cancelled submitted', function () {
      // Remove 'verification_code' from attributes so we don't continue
      // sending it on other forms
      this.form.model.unset('verification_code');
    }, this);
  },

  resend_verify: function (e) {
    e.preventDefault();
    $.get($(e.currentTarget).attr('href'), this.resend_verify_success);
  },

  resend_verify_success: function () {
    this.form.reset();
    this.form.errors = {};
    this.form.successes = {
      verification_code: [
        'Please check your device for the new verification code message',
      ],
    };
    this.form.render();
  },
});



// WEBPACK FOOTER //
// ./static/js/views/verify_phone.js